"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=2776%3A732))
 * @lastsynced 2026-10-29T13:53:21.292Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Save = createSVGIcon(
  <path
    d="M18.857 23.143 12 16.286l-6.857 6.857V2.57A1.714 1.714 0 0 1 6.857.857h10.286a1.714 1.714 0 0 1 1.714 1.714z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Save",
  (strictLocalize) => ({
    color: iconColor.primary,
    fill: "none",
    titleAccess: strictLocalize({
      id: "Mrt+XC",
      defaultMessage: "Save",
      description: {
        text: "Message for screen readers when only the Save icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
    className: iconCls(),
  })
);
